import { Quote } from "@/shared/types/Quote.interface";

export function getActivePetIndex(policies: Quote["policies"] | undefined, newPetId: string) {
    if (!policies) return -1;
    return policies.findIndex(p => p.id === newPetId);
}
